const firebaseConfig = {
  apiKey: "AIzaSyALvhhlVKI1lNhkfFxyqleB4-0luczgbSs",
  authDomain: "leatvprod-fa396.firebaseapp.com",
  projectId: "leatvprod-fa396",
  storageBucket: "leatvprod-fa396.firebasestorage.app",
  messagingSenderId: "958012131857",
  appId: "1:958012131857:web:c4a7b0e75f9fb0a5147fb0"
}

export default firebaseConfig